import useAuthStore, { selectFeature } from 'stores/authStore';

/**
 * Is feature flag *key* on for the active tenant (from /me)?
 *
 * Gates what the UI *shows*, never what the user *may do*: the backend checks
 * every flag itself. Keys are literals in the public bundle, so a key never
 * names a customer.
 */
export default function useFeature(key) {
  return useAuthStore(selectFeature(key));
}
